import { post } from './base-api';

const fetchAssignedAdmins = (data: any, config = {}) => post('/userConversations', data, config);

const getAnnouncements = (body = {}) => post('/announcements', body, {});

export { fetchAssignedAdmins, getAnnouncements };
